import React from 'react';

const PlugIcon = () => (
  <svg
    width="20"
    height="24"
    viewBox="0 0 20 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.66667 1.53191C3.66667 0.684573 4.37422 0 5.25 0C6.12578 0 6.83333 0.684573 6.83333 1.53191V6.12764H3.66667V1.53191ZM13.1667 1.53191C13.1667 0.684573 13.8742 0 14.75 0C15.6258 0 16.3333 0.684573 16.3333 1.53191V6.12764H13.1667V1.53191ZM1.81944 7.65967C1.09074 7.65967 0.5 8.23122 0.5 8.93626C0.5 9.6413 1.09073 10.2129 1.81944 10.2129H4.19362V10.193H15.8047V10.2129H18.1806C18.9093 10.2129 19.5 9.6413 19.5 8.93626C19.5 8.23122 18.9093 7.65967 18.1806 7.65967H1.81944ZM2.08367 10.2129H4.19362V11.5363C4.19362 14.7426 6.79286 17.3419 9.99918 17.3419C13.2055 17.3419 15.8047 14.7426 15.8047 11.5363V10.2129H17.917V11.7448C17.917 15.4501 15.1956 18.5427 11.5837 19.2512V22.4682C11.5837 23.3155 10.8761 24.0001 10.0003 24.0001C9.12455 24.0001 8.417 23.3155 8.417 22.4682V19.2512C4.80502 18.5427 2.08367 15.4501 2.08367 11.7448V10.2129Z"
      fill="#6A7880"
    />
  </svg>
);

export default PlugIcon;
